module.exports = __webpack_public_path__ + "img/nav-08.47035fdd.jpg";